import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import AllQuestions from '../AllData/AllQuestions';
import './../../pagescss/QuizDetailsPage.css';
import Loading from '../home/Loading';
import Latex from 'react-latex';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';
import QuestionImage from './QuestionImage';

const formatTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hours < 10 ? "0" : ""}${hours}:${minutes < 10 ? "0" : ""}${minutes}:${secs < 10 ? "0" : ""}${secs}`;
};

// Function to safely parse answers
const parseAnswers = (answers) => {
  if (Array.isArray(answers)) return answers;

  if (typeof answers === 'string') {
    try {
      const parsed = JSON.parse(answers);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error('Error parsing answers JSON:', error);
      return [];
    }
  }

  return [];
};

// Function to calculate submission statistics
const calculateSubmissionStats = (answers) => {
  const parsedAnswers = parseAnswers(answers);
  let totalMarks = 0;
  let totalCorrectAns = 0;
  let totalIncorrectAns = 0;
  let totalNotAns = 0;

  parsedAnswers.forEach((ans) => {
    if (ans.userAnswer === ans.correctAnswer) {
      totalMarks += 4;
      totalCorrectAns++;
    } else if (ans.userAnswer === "option1" || ans.userAnswer === "option2" || ans.userAnswer === "option3" || ans.userAnswer === "option4") {
      totalMarks -= 1;
      totalIncorrectAns++;
    } else {
      totalNotAns++;
    }
  });

  return {
    totalMarks,
    totalCorrectAns,
    totalIncorrectAns,
    totalNotAns,
    percentage: parsedAnswers.length > 0 ? Math.round((totalMarks * 100) / (parsedAnswers.length * 4)) : 0
  };
};

function QuizDetailsPage() {
  const [quizSubmissions, setQuizSubmissions] = useState([]);
  const [submissions, setSubmissions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedQuizName, setSelectedQuizName] = useState('');

  const navigate = useNavigate();
  const { quizId, type, subject, topic, quizNo, subjectName } = useParams();

  const isPayment = localStorage.getItem('userPayment');

  const filterByPhoneAllQuizSubmissions = submissions;
  const loading = false;
  const questions = AllQuestions;
  const [bookmarkedQuestions, setBookmarkedQuestions] = useState([]);
  const [questionsId, setQuestionsId] = useState([]);

  const [showContent, setShowContent] = useState(false);
  const handleToggle = () => {
    setShowContent(!showContent);
  };

  // Load bookmarks from localStorage
  useEffect(() => {
    const storedBookmarks = localStorage.getItem('questionBookmarks');
    if (storedBookmarks) {
      setBookmarkedQuestions(JSON.parse(storedBookmarks));
    }
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem('quizSubmissions');
    const data = saved ? JSON.parse(saved) : [];
    setSubmissions(data);
  }, []);

  useEffect(() => {
    if (quizId && filterByPhoneAllQuizSubmissions.length > 0) {
      const filtered = filterByPhoneAllQuizSubmissions.filter(data => data.quizId === quizId);

      // Process submissions to ensure answers are arrays
      const processedSubmissions = filtered.map(submission => ({
        ...submission,
        answers: parseAnswers(submission.answers)
      }));

      setQuizSubmissions(processedSubmissions);

      const allQuestionIds = processedSubmissions.flatMap(submission =>
        submission.answers.map(answer => answer.questionId)
      );
      setQuestionsId([...new Set(allQuestionIds)]); // Remove duplicates
    } else {
      setQuizSubmissions([]);
      setQuestionsId([]);
    }
  }, [filterByPhoneAllQuizSubmissions, quizId]);

  // Trigger modal display
  const triggerResetModal = (quizName) => {
    setSelectedQuizName(quizName || 'this quiz');
    setShowModal(true);
  };

  // Perform actual reset execution on modal confirm
  const handleConfirmReset = () => {
    const saved = localStorage.getItem('quizSubmissions');
    const data = saved ? JSON.parse(saved) : [];

    const updatedSubmissions = data.filter((item) => item.quizId !== quizId);

    localStorage.setItem('quizSubmissions', JSON.stringify(updatedSubmissions));
    setSubmissions(updatedSubmissions);
    setQuizSubmissions([]);
    setShowModal(false);
  };

  const compareQuestionIds = (id1, id2) => {
    const extractId = (id) => {
      if (typeof id === 'object' && id.$oid) {
        return id.$oid;
      }
      return id;
    };
    return extractId(id1) === extractId(id2);
  };

  const handleBookmark = (questionId) => {
    const isBookmarked = bookmarkedQuestions.some(
      bq => compareQuestionIds(bq.questionId, questionId)
    );

    let updatedBookmarks;

    if (isBookmarked) {
      updatedBookmarks = bookmarkedQuestions.filter(
        bq => !(compareQuestionIds(bq.questionId, questionId))
      );
    } else {
      const newBookmark = {
        questionId: questionId,
        timestamp: new Date().toISOString()
      };
      updatedBookmarks = [...bookmarkedQuestions, newBookmark];
    }

    localStorage.setItem('questionBookmarks', JSON.stringify(updatedBookmarks));
    setBookmarkedQuestions(updatedBookmarks);
  };

  const isQuestionBookmarked = (questionId) => {
    return bookmarkedQuestions.some(
      bq => compareQuestionIds(bq.questionId, questionId)
    );
  };

  const renderWithLatex = (text) => {
    if (!text) return null;
    if (text.includes('$') || text.includes('\\')) {
      return <Latex>{text}</Latex>;
    }
    return text;
  };

  if (loading) {
    return <Loading message='Loading......' />;
  }



  return (
    <div className="quiz-details">
      <TopNavbar name="Mock Test Attempt Details" />
      <TopHeader name="Mock Test Attempt Details" />

      <div className="quiz-details__card">
        {quizSubmissions.length === 0 ? (
          <>
            <br></br> <br></br> <br></br> <br></br> <br></br> <br></br>
            <Link
              to={`/number-of-questions/${type}/${subject}/${topic}/${quizNo}/${subjectName}`}
              className="link"

            >
              <div className="topic-card">
                <p>{subjectName}</p>  <br></br>
                <div className="topic-header">
                  <h2>📋 Start  mock test ➔</h2>
                </div>
              </div>
            </Link>
          </>
        ) : (
          <ul className="submissions">
            {quizSubmissions.map((submission, submissionIndex) => {
              const stats = calculateSubmissionStats(submission.answers);
              const answersArray = parseAnswers(submission.answers);

              return (
                <li key={submission.submissionId || submission._id || submissionIndex} className="submission">
                  <div className="submission__header">
                    <div className="submission__info">
                      <p className="submission__text">
                        <span className="submission__label">Mock test :</span> {submission.quizName} mock test
                      </p>
                      <p className="submission__text">
                        <span className="submission__label">Submitted:</span> {submission.submittedAt}
                      </p>
                      <p className="submission__text">
                        <span className="submission__label">Time Taken:</span> {formatTime(submission.timeTaken)}
                      </p>
                    </div>

                    <div className="submission__info">
                      <p className="submission__text">
                        <span className="submission__label">Score:</span> {stats.totalMarks}/{answersArray.length * 4} ({stats.percentage}%)
                      </p>
                      <p className="submission__text">
                        <span className="submission__label">Correct:</span> {stats.totalCorrectAns}
                      </p>
                      <p className="submission__text">
                        <span className="submission__label">Incorrect:</span> {stats.totalIncorrectAns}
                      </p>
                      <p className="submission__text">
                        <span className="submission__label">Not Answered:</span> {stats.totalNotAns}
                      </p>
                    </div>
                  </div>

                  <div
                    className="submission__actions"
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                      marginTop: '10px'
                    }}
                  >

                    {type === "previousyearquestions" ? (<></>) : (<>
                      <button
                        onClick={() => triggerResetModal(submission.quizName)}
                        className="reset-test-btn"
                        style={{
                          backgroundColor: '#dc3545',
                          color: '#fff',
                          border: 'none',
                          padding: '8px 16px',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontWeight: 'bold'
                        }}
                      >
                        Reset Test
                      </button>
                    </>)}

                    <Link
                      to={`/quiz-restarting/${quizId}`}
                      className="remock-test-link"
                      style={{
                        backgroundColor: '#ffe54f',
                        color: '#1b1717',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textDecoration: 'none'
                      }}
                    >
                      Retest
                    </Link>

                  </div>

                  <h3 className="submission__questions-title">
                    Questions and Answers
                  </h3>

                  <ul className="questions">
                    {answersArray.map((answer, ansIndex) => {
                      if (!answer) return null;

                      const questionId = answer.questionId;
                      const correctAns = answer.correctAnswer;
                      const userAns = answer.userAnswer;
                      let correctAnswer = "Not answered";
                      let userAnswer = "Not answered";

                      const questionData = questions.find(q => (q._id?.$oid || q._id) === questionId);
                      const isData = !!questionData;
                      const photo = isData ? questionData.question_img : null;

                      if (correctAns === "option1") {
                        correctAnswer = isData ? questionData.option1 : correctAns;
                      } else if (correctAns === "option2") {
                        correctAnswer = isData ? questionData.option2 : correctAns;
                      } else if (correctAns === "option3") {
                        correctAnswer = isData ? questionData.option3 : correctAns;
                      } else if (correctAns === "option4") {
                        correctAnswer = isData ? questionData.option4 : correctAns;
                      }

                      if (userAns === "option1") {
                        userAnswer = isData ? questionData.option1 : userAns;
                      } else if (userAns === "option2") {
                        userAnswer = isData ? questionData.option2 : userAns;
                      } else if (userAns === "option3") {
                        userAnswer = isData ? questionData.option3 : userAns;
                      } else if (userAns === "option4") {
                        userAnswer = isData ? questionData.option4 : userAns;
                      }

                      return (
                        <li key={`${submission.submissionId}-${ansIndex}`} className={`question ${answer.isCorrect ? 'question--correct' : 'question--incorrect'}`}>
                          <button
                            onClick={() => handleBookmark(answer.questionId)}
                            className={`bookmark-button ${isQuestionBookmarked(answer.questionId) ? 'bookmarked' : ''}`}
                          >
                            <span>{isQuestionBookmarked(answer.questionId) ? 'Marked' : 'Mark'}</span>
                          </button>

                          {questionData.type === "dpp" ? (<>
                            {questionData.question ? (
                              <p className="question-text">
                                {renderWithLatex(answer.questionText)}
                              </p>
                            ) : (
                              <div className="question__image-container">
                                <img
                                  src={`/questionsPhoto/${photo}`}
                                  alt="Question"
                                  className="question__image"
                                />
                              </div>
                            )}

                            <button onClick={handleToggle} style={{ fontSize: "8px", padding: "01px" }}>
                              {showContent ? "Hide source image" : "View source image"}
                            </button>
                            {showContent && (
                              <div style={{ padding: "5px" }}>
                                <div className="question__image-container">
                                  <QuestionImage
                                    src={`/questionsPhoto/${photo}`}
                                    alt="Question"
                                  />
                                </div>
                              </div>
                            )}

                          </>) : (<>
                            {photo ? (
                              <div className="question__image-container">
                                <QuestionImage
                                  src={`/questionsPhoto/${photo}`}
                                  alt="Question"
                                />
                              </div>
                            ) : (
                              <>{renderWithLatex(answer.questionText)}</>
                            )}
                          </>)}


                          <div className="question__answers">
                            <div className="answer">
                              <p className="answer__label">Your Answer:</p>
                              <p className={`answer__text answer__text--user ${answer.isCorrect ? 'answer__text--correct' : 'answer__text--incorrect'}`}>
                                {renderWithLatex(userAnswer)}
                              </p>
                            </div>
                            <div className="answer">
                              <p className="answer__label">Correct Answer:</p>
                              <p className="answer__text answer__text--correct">
                                {renderWithLatex(correctAnswer)}
                              </p>

                              <Link to={`/question-solution/${questionId}`} className="question__solution-link">
                                View Solution
                              </Link>
                            </div>
                          </div>
                          <br />

                          <p className={`question__status ${answer.isCorrect ? 'question__status--correct' : 'question__status--incorrect'}`}>
                            {answer.isCorrect ? "✓ Correct" : "✗ Incorrect"}
                          </p>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              );
            })}
          </ul>
        )}
      </div>

      {/* POPUP MODAL */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: '#fff',
            borderRadius: '16px',
            padding: '24px 28px',
            maxWidth: '420px',
            width: '90%',
            boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
            fontFamily: 'Arial, sans-serif'
          }}>
            <h2 style={{
              margin: '0 0 12px 0',
              fontSize: '22px',
              fontWeight: '700',
              color: '#000'
            }}>
              Confirm Reset
            </h2>
            <p style={{
              margin: '0 0 24px 0',
              fontSize: '15px',
              color: '#222',
              lineHeight: '1.4'
            }}>
              This will generate new questions and permanently delete your previous questions for this test.
            </p>
            <div style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '12px'
            }}>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  backgroundColor: '#cddc39',
                  color: '#000',
                  border: 'none',
                  padding: '10px 24px',
                  borderRadius: '6px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              {isPayment ? (<>
                <button
                  onClick={handleConfirmReset}
                  style={{
                    backgroundColor: '#007bff',
                    color: '#fff',
                    border: 'none',
                    padding: '10px 24px',
                    borderRadius: '6px',
                    fontSize: '16px',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  Reset
                </button>
              </>) : (<>
                <Link to="/product-list" className="pay-button">
                  Subscribe & Unlock Now
                </Link>
              </>)}

            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default QuizDetailsPage;